import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationBloc } from '@kp/auth/authentication.bloc';
import { AuthDataService, ThemeService, TitleService, productDisplayName } from '@kservice';

@Component({
  selector: 'kp-resend-code',
  templateUrl: './resend-code.component.html',
  styleUrls: ['./resend-code.component.scss'],
})
export class ResendCodeComponent implements OnInit {
  private _title = 'Resend Password Reset Email';
  productName = productDisplayName;

  constructor(
    private authenticationBloc: AuthenticationBloc,
    private authDataService: AuthDataService,
    private router: Router,
    private titleService: TitleService,
    public themeService: ThemeService
  ) {}
  ngOnInit() {
    this.titleService.set(this._title);
  }

  resend() {
    const email = this.authenticationBloc.resetEmail || this.authDataService.loadToken()?.user?.email;
    this.authenticationBloc.requestPasswordReset(email);
    return this.router.navigate(['/login/reset/password']);
  }
}
